<template>
  <div class=" text-center p-8">
    <!--<div class="text-2xl font-bold">Fin Akyaka Online Menu</div>-->
    <div class="lg:flex xl:flex justify-center text-center p-8">
      <img src="../../src/assets/1.jpg" alt="menu page 1">
      </div>
  </div>
</template>

<script>
export default {
  name: "mainComponent",
  components: {},
  data() {
    return {
      dataSet: [],
    };
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
